import { getLocalizedPath } from "./getLocalizedPath";

/**
 * Post-login landing path for the developer portal. Named `…DashboardPath`
 * for historical reasons (we used to land on a placeholder dashboard); it
 * now points at the inventory listing since that's the portal's main page.
 */
export const getDeveloperDashboardPath = () =>
  getLocalizedPath("/developer/inventory");
